import { Box, Typography } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useTranslation } from 'react-i18next';
import { formatOfferEta, readOfferEta } from '../../utils/offer_presentation';

export default function OfferEta({ offer }) {
  const { t, i18n } = useTranslation();
  const pickup = formatOfferEta(readOfferEta(offer, 'pickup'), i18n.language);
  const delivery = formatOfferEta(readOfferEta(offer, 'delivery'), i18n.language);
  if (!pickup && !delivery) return null;
  return (
    <Box sx={{ my: 2, p: 1.5, bgcolor: 'action.hover', borderRadius: 2 }}>
      {[[pickup, 'offer.estimated_pickup'], [delivery, 'offer.estimated_delivery']].map(([time, label]) => time && (
        <Box key={label} sx={{ display: 'flex', gap: 1, alignItems: 'center', mb: 0.5 }}>
          <AccessTimeIcon fontSize="small" color="secondary" />
          <Typography variant="body2">{t(label)}: {time} ({t('request.uae_time')})</Typography>
        </Box>
      ))}
      <Typography variant="caption" color="text.secondary">{t('offer.eta_hint')}</Typography>
    </Box>
  );
}
